import moment from 'moment';

import { l } from 'app/scripts/lib/localize';

// Generate a name for a pasted image file, using the current date and time
export const pastedFileName = () => {
  const now = moment();
  const name = l('pasted file name', {
    date: now.format('l'),
    time: now.format('LTS'),
  });

  return `${name}.png`;
};
